import { useAppDispatch } from 'shared/store/store'
import { useHistory, useLocation } from 'react-router-dom'
import { setActiveClientId } from 'shared/store/clients'

const RELATION_PICKER_PARAMS = 'rpp'

const useCheckParamsForRelationPicker = () => {
  const dispatch = useAppDispatch()
  const { search } = useLocation()
  const { replace } = useHistory()

  const params = new URLSearchParams(search)

  const _deleteRelationPickerParam = () => {
    params.delete(RELATION_PICKER_PARAMS)
    replace({ search: params.toString() })
  }

  const resetRelationPickerIfRelationPickerParam = () => {
    const resetRelations = params.get(RELATION_PICKER_PARAMS)

    if (!resetRelations) return

    dispatch(setActiveClientId(null))

    _deleteRelationPickerParam()
  }

  return resetRelationPickerIfRelationPickerParam
}

export default useCheckParamsForRelationPicker
